
class PollingManager {
  constructor(interval = 2000) {
    this.activePolls = new Map();
    this.interval = interval;
  }

  startPolling(id, pollFn, onComplete, onError) {
    if (this.activePolls.has(id)) {
      console.warn(`Already polling for ID: ${id}`);
      return;
    }

    this._executePoll(id, pollFn, onComplete, onError);

    const intervalId = setInterval(() => {
      this._executePoll(id, pollFn, onComplete, onError);
    }, this.interval);

    this.activePolls.set(id, {
      intervalId,
      pollFn,
      onComplete,
      onError,
      startedAt: new Date()
    });
  }

  async _executePoll(id, pollFn, onComplete, onError) {
    try {
      const result = await pollFn();

      if (result && result.shouldStop) {
        this.stopPolling(id);
        if (onComplete) {
          onComplete(result.data);
        }
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  }

  stopPolling(id) {
    const poll = this.activePolls.get(id);
    if (poll) {
      clearInterval(poll.intervalId);
      this.activePolls.delete(id);
      return true;
    }
    return false;
  }

  stopAll() {
    const count = this.activePolls.size;
    for (const [id, poll] of this.activePolls) {
      clearInterval(poll.intervalId);
    }
    this.activePolls.clear();
    return count;
  }

  isPolling(id) {
    return this.activePolls.has(id);
  }

  getActivePollCount() {
    return this.activePolls.size;
  }

  getPollInfo(id) {
    const poll = this.activePolls.get(id);
    if (poll) {
      return {
        id,
        startedAt: poll.startedAt,
        duration: new Date() - poll.startedAt,
        interval: this.interval
      };
    }
    return null;
  }
}

export const executionPolling = new PollingManager(2000); // For execution status (2 seconds)
export const documentPolling = new PollingManager(2000); // For document creation (2 seconds)

export default PollingManager;
